<template>
    <tr v-bind:class="rowClass" >
        <td >
            <input :id="'row_number__' + id"
                   :name="'row_number__' + id"
                   type="text"
                   disabled="disabled"
                   class="form-control form-control-sm"
                   style="width: 30px; text-align: center; padding: 0; background-color: #afafaf;"
                   :value="rowNumber">
        </td>
        <!--          :style="'min-width: ' + rowNumber.length * 1.5 + 'em;'"-->
        <template v-for="(property, cellKey) in gridItem">
            <td :id="'col__'+cellKey+'__'+id" :key="cellKey"
                v-if="! cellKey.startsWith('is_committed') && ! cellKey.startsWith('is_restored') && ! cellKey.startsWith('is_deleted')">
                <!-- Remove or disable toolbox after DE2021 VAT change has been executed (remove @contextmenu if no longer relevant) -->
                <toolbox v-if="showToolboxFor.includes(cellKey)"
                         :target-id="'col__'+cellKey+'__'+id"
                         :stored-data="property"
                         @update-grid="updateGridItemValues"
                >
                </toolbox>
                <input-id v-if="cellTypeId.includes(cellKey)"
                          :class="setCellClass(cellKey)"
                          :tag="cellKey + '__' + id"
                          :stored-data="property"
                          :brand-id="brandId"
                          :country-id="countryId"
                          :route="route"
                          @dataUpdated="onDataUpdated"
                          :ref="cellKey + '__' + id"
                          :disabled="isRowLocked || isFixed(cellKey)"
                          :committed="isRowCommitted"
                          :grid-item-index="gridItemIndex">
                </input-id>
                <input-gid v-if="cellTypeGid.includes(cellKey)"
                           :class="setCellClass(cellKey)"
                           :tag="cellKey + '__' + id"
                           :stored-data="property"
                           :brand-id="brandId"
                           :country-id="countryId"
                           :route="route"
                           @dataUpdated="onDataUpdated"
                           :ref="cellKey + '__' + id"
                           :disabled="isRowLocked || isFixed(cellKey)"
                           :committed="isRowCommitted"
                           :grid-item-index="gridItemIndex">
                </input-gid>
                <input-text v-else-if="cellTypeText.includes(cellKey)"
                            :class="setCellClass(cellKey)"
                            :tag="cellKey + '__' + id"
                            :stored-data="property"
                            :brand-id="brandId"
                            :country-id="countryId"
                            :route="route"
                            @dataUpdated="onDataUpdated"
                            :ref="cellKey + '__' + id"
                            :disabled="isRowLocked || isFixed(cellKey)"
                            :committed="isRowCommitted"
                            :grid-item-index="gridItemIndex">
                </input-text>
                <input-number v-else-if="cellTypeNumber.includes(cellKey)"
                              :class="setCellClass(cellKey)"
                              :tag="cellKey + '__' + id"
                              :stored-data="property"
                              :brand-id="brandId"
                              :country-id="countryId"
                              :route="route"
                              @dataUpdated="onDataUpdated"
                              :ref="cellKey + '__' + id"
                              :disabled="isRowLocked || isFixed(cellKey)"
                              :committed="isRowCommitted"
                              :grid-item-index="gridItemIndex">
                </input-number>
                <input-date v-else-if="cellTypeDate.includes(cellKey)"
                            :class="setCellClass(cellKey)"
                            :tag="cellKey + '__' + id"
                            :stored-data="property"
                            :brand-id="brandId"
                            :country-id="countryId"
                            :route="route"
                            @dataUpdated="onDataUpdated"
                            :ref="cellKey + '__' + id"
                            :disabled="isRowLocked || isFixed(cellKey)"
                            :committed="isRowCommitted"
                            :grid-item-index="gridItemIndex">
                </input-date>
                <input-category v-else-if="cellTypeCategory.includes(cellKey)"
                                :class="setCellClass(cellKey)"
                                :tag="cellKey + '__' + id"
                                :stored-data="property"
                                :brand-id="brandId"
                                :country-id="countryId"
                                :route="route"
                                @dataUpdated="onDataUpdated"
                                :ref="cellKey + '__' + id"
                                :disabled="isRowLocked || isFixed(cellKey)"
                                :committed="isRowCommitted"
                                :grid-item-index="gridItemIndex">
                </input-category>
                <data-select v-else-if="cellTypeSelect.includes(cellKey)"
                             :class="setCellClass(cellKey)"
                             :tag="cellKey + '__' + id"
                             :options="getSelectOptions(cellKey)"
                             :stored-data="property"
                             :brand-id="brandId"
                             :country-id="countryId"
                             :route="route"
                             @dataUpdated="onDataUpdated"
                             @rowDeleteStateChanged="onRowDeleteStateChanged"
                             @optionalExtraSelect="onOptionalExtraSelect"
                             :ref="cellKey + '__' + id"
                             :disabled="isRowLocked || isFixed(cellKey)"
                             :committed="isRowCommitted"
                             :grid-item-index="gridItemIndex">
                </data-select>
            </td>
        </template>
    </tr>
</template>

<script>
import baseGridMixin from './BaseGridMixin.vue';
import cellTypeMixin from './CellTypeMixin.vue';
import ContextMenuMixin from "./ContextMenuMixin";

export default {
    mixins: [baseGridMixin, cellTypeMixin, ContextMenuMixin],
    props: {
        id: {
            type: String,
            required: true
        },
        brandId: {
            type: Number|String,
            required: true
        },
        countryId: {
            type: String,
            required: true
        },
        route: {
            type: String,
            required: true
        },
        isLocked: {
            type: Boolean,
            default: false
        },
        gridItemIndex: {
            type: Number|String,
            default: "1"
        },
        isFirstRowOfNewCategory: {
            type: Boolean,
            required: true
        }
    },

    data () {
        return {
            gridItem: null,
            isRowUpdated: null,
            isRowDeleted: null,
            isRowLocked: null,
            isRowCommitted: null,
            isRestored: null,
            rowNumber: (this.gridItemIndex + 1).toString(),
            versionsItems: {
                name: 'local_versions__name',
                inception_date: 'prices__data_date',
                limited_edition: 'versions__limited_edition',
                vehicle_category: 'versions__vehicle_category',
            },
            coreSpecsItemTranslations: {
                engine_capacity: 'core_specs__engine_capacity',
                engine_power_kw: 'local_specs__engine_power_kw',
                engine_power_hp: 'local_specs__engine_power_hp',
                engine_power_rpm: 'local_specs__engine_power_rpm',
                emission_co2: 'core_specs__emission_co2',
                emission_class: 'core_specs__emission_class',
                gearbox_no_of_gears: 'core_specs__gearbox_no_of_gears',
            },
            coreSpecsItemFormats: {
                emission_class: 'trim',
            },
            showToolboxFor: ['prices__price_incl_tax'],
        }
    },

    beforeMount () {
        let gridItem = this.$store.state.gridItems[this.gridItemIndex].data;

        this.gridItem = gridItem;
        this.isRowUpdated = ! gridItem.is_committed;
        this.isRowLocked = this.isLocked || gridItem.is_committed;
        this.isRowCommitted = gridItem.is_committed;
        this.isRestored = gridItem.is_restored;
    },

    mounted () {
        for (var refName in this.$refs) {
            this.$refs[refName][0].determineCellState();
        }
    },
    computed: {
        rowClass: function () {
            let tClass = '';
            if (this.isRowCommitted) {
                tClass = 'row-committed';
            }
            else if (this.isRowDeleted) {
                tClass = 'row-deleted';
            }
            else if (this.isRestored) {
                tClass = 'row-restored';
            }
            else if (this.isRowUpdated) {
                tClass = 'rowupdated';
            }
            if (this.isFirstRowOfNewCategory) {
                tClass = tClass + ' ' + 'dcx-grid-category-first-row';
            }
            return tClass;
        },
        modelYearOrVersionIdWasUpdated: function () {
            if (!this.gridItem) {
                return false;
            }
            return this.gridItem['versions__id'].is_updated || this.gridItem['prices__model_year'].is_updated;
        },
        coreSpecsKeys: function () {
            if (!this.modelYearOrVersionIdWasUpdated) {
                return null
            }
            return {
                originalId: parseInt(this.gridItem['versions__id'].original),
                updatedId: parseInt(this.gridItem['versions__id'].updated),
                originalModelYear: parseInt(this.gridItem['prices__model_year'].original),
                updatedModelYear: parseInt(this.gridItem['prices__model_year'].updated)
            }
        },
        axiosParamsFetchCoreSpecsItems: function () {
            const params = new URLSearchParams();
            if (this.coreSpecsKeys) {
                params.append('origId', this.coreSpecsKeys.originalId.toString());
                params.append('updId', this.coreSpecsKeys.updatedId.toString());
                params.append('origMY', this.coreSpecsKeys.originalModelYear.toString());
                params.append('updMY', this.coreSpecsKeys.updatedModelYear.toString());
            }
            return params;
        },
        newVersionJson: function () {
            let jsonOut = {};
            let items = this.versionsItems;
            let data = this.gridItem;
            jsonOut['id'] = '000000';
            for (let item in items) {
                if (items.hasOwnProperty(item)) {
                    if (data.hasOwnProperty(items[item])) {
                        let cellData = data[items[item]];
                        if (cellData.hasOwnProperty('is_updated')) {
                            if (cellData['is_updated']) {
                                jsonOut[item] = cellData['updated'];
                            } else {
                                jsonOut[item] = cellData['original'];
                            }
                        }
                    }
                }
            }
            return jsonOut;
        },
    },
    methods: {
        handleContextMenu: function (id, countryId, brandId, storedData, key) {
            // ------------------------------------------------------------------------------------
            // The 'right-click' event below needs to be inserted in the grid row's <td> tag
            // @contextmenu.prevent="handleContextMenu(id, countryId, brandId, property, cellKey)"
            // ------------------------------------------------------------------------------------
            this.showToolbox(id, countryId, brandId, storedData, key);
        },
        setCellClass: function (cellKey) {
            if (this.isRowLocked || this.isFixed(cellKey)) {
                return 'text-inactive';
            }
        },

        onRowDeleteStateChanged: function (tag, event) {
            if (event === 'D') {
                this.isRowDeleted = true;
                this.isRowLocked = true;
                this.isRowUpdated = false;
            } else {
                this.isRowLocked = false;
                this.isRowDeleted = false;
            }
        },

        onOptionalExtraSelect: function (tag, event) {
            // If the updated cell is an optianal extra availability select
            // Pick up the selected option and enable the corresponding price field if appropriate or clear it if not
            if (tag && this.isOptionalExtraSelect(tag.replace('__' + this.id, ''))) {
                let priceCell = this.$refs[tag.replace('_avail__', '_price__')][0];
                if (['O', 'P', 'I'].includes(event)) {
                    priceCell.notApplicable = false;
                } else {
                    priceCell.value = "";
                    priceCell.storedData.updated = null;
                    priceCell.storedData.is_updated = true;
                    //TODO: Check what the effects of commenting this out has
                    // priceCell.determineCellState();
                    priceCell.notApplicable = true;
                }
            }
        },

        onDataUpdated: function () {
            this.$nextTick(() => {
                this.isRowUpdated = false;
                for (var refName in this.$refs) {
                    if (this.$refs[refName][0].isUpdated) {
                        this.isRowUpdated = true;
                        this.$emit('dataUpdated');
                    }
                }
            });
        },
        translateCoreSpecsItemName: function (itemName) {
            if (!this.coreSpecsItemTranslations.hasOwnProperty(itemName)) {
                return null
            }
            return this.coreSpecsItemTranslations[itemName];
        },
        formatDataValue: function (itemName, value) {
            if (!this.coreSpecsItemFormats.hasOwnProperty(itemName)) {
                return value
            }
            switch (this.coreSpecsItemFormats[itemName]) {
                case 'trim':
                    return value.trim();
                    break;
            }
            return value;
        },
        updateItemValues: function (json) {
            let jsonOut = {};
            JSON.parse(JSON.stringify(json), (key, value) => {
                /** Execute for each value having a matching grid item */
                if (this.translateCoreSpecsItemName(key)) {
                    let targetItem = this.translateCoreSpecsItemName(key)
                    let tag = targetItem + '__' + this.id;
                    let targetValue = this.formatDataValue(key, value);
                    if (!targetValue || targetValue === '') {targetValue = null}
                    this.gridItem[targetItem].updated = targetValue;
                    this.$refs[tag][0].value = targetValue;
                    this.$refs[tag][0].isUpdated = true;
                    // Add data to jsonOut
                    jsonOut[targetItem] = targetValue;
                }
            });
            /** Store the changed values */
            this.updateChangedGridItems(this.id, jsonOut);
        },
        updateGridItemValues: function (json) {
            let jsonOut = {};
            JSON.parse(json, (key, value) => {
                /** Execute for each item in the JSON string */
                if (!(value instanceof Object)) {
                    let tag = key + '__' + this.id;
                    let targetValue = this.formatDataValue(key, value);
                    if (!targetValue) {targetValue = ''}
                    this.gridItem[key].updated = targetValue;
                    this.$refs[tag][0].value = targetValue;
                    this.$refs[tag][0].isUpdated = true;
                    // Add data to jsonOut
                    jsonOut[key] = targetValue;
                }
            });
            /** Store the changed values */
            this.updateChangedGridItems(this.id, jsonOut);
            this.onDataUpdated();
        },

        updateTemporaryGridRecords: function (tag, value) {
            /** make the axios call */
            axios.post('/update-value', {
                brand_id: this.brandId,
                country_id: this.countryId,
                tag: tag,
                value: value,
                reset: false
            })
                .then(response => {
                    return response.data;
                })
                .catch(error => {
                    return false;
                });
            return true;
        },
        updateChangedGridItems: function (id, json) {
            /** make the axios call */
            axios.post('update-item-values', {
                brand_id: this.brandId,
                country_id: this.countryId,
                id: id,
                items: JSON.stringify(json),
                reset: false
            })
                .then(response => {
                    return response.data;
                })
                .catch(error => {
                    return false;
                });
            return true;
        },
        fetchCoreSpecsItems: function () {
            axios.get('/api/fetch-core-specs', {
                params: this.axiosParamsFetchCoreSpecsItems
            })
                .then(response => {
                    //console.log(response.data);
                    this.updateItemValues(response.data);
                    return response.data;
                })
                .catch(error => {
                    // console.log(error);
                    return false;
                });
            return true;
        },
    },
    watch: {
        /** Monitors changes to the ModelYear or global VersionId */
        modelYearOrVersionIdWasUpdated: function () {
            if (this.modelYearOrVersionIdWasUpdated && this.coreSpecsKeys) {
                let lookupKey = 'updatedId';
                if (this.coreSpecsKeys.hasOwnProperty(lookupKey)) {
                    if (this.coreSpecsKeys[lookupKey] > 0) {
                        this.fetchCoreSpecsItems();
                    }
                }
            }
        }
    }
}
</script>
